// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__Xrq4v","btnText":"button_btnText__cd7OD","btnHover":"button_btnHover__N0zCi","slideTransition":"button_slideTransition__AgzgX"};